import { Heart } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { useState } from 'react';

export const FavoriteHeart = ({ type, id, size = 'md', className = '', testId }) => {
  const { user, isFavorite, toggleFavorite } = useAuth();
  const navigate = useNavigate();
  const [popping, setPopping] = useState(false);
  const active = isFavorite(type, id);

  const sizes = {
    sm: 'h-8 w-8',
    md: 'h-9 w-9',
    lg: 'h-11 w-11',
  };
  const iconSizes = {
    sm: 'h-4 w-4',
    md: 'h-[18px] w-[18px]',
    lg: 'h-5 w-5',
  };

  const handle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      toast('Sign in to save favorites', {
        description: 'Create your beauty profile to save hacks and products.',
        action: { label: 'Sign in', onClick: () => navigate('/login') },
      });
      return;
    }
    setPopping(true);
    setTimeout(() => setPopping(false), 320);
    const res = await toggleFavorite(type, id);
    if (res?.error) {
      toast.error('Couldn’t update favorites');
    } else if (res?.added) {
      toast.success('Saved to your favorites');
    } else {
      toast('Removed from favorites');
    }
  };

  return (
    <Button
      type="button"
      onClick={handle}
      variant="ghost"
      size="icon"
      aria-pressed={active}
      aria-label={active ? 'Remove from favorites' : 'Add to favorites'}
      data-testid={testId || `favorite-heart-${type}-${id}`}
      className={`${sizes[size]} rounded-full bg-card/90 backdrop-blur border border-border/70 hover:bg-card shadow-sm ${className}`}
    >
      <Heart
        className={`${iconSizes[size]} transition-colors ${
          active ? 'text-primary fill-primary' : 'text-muted-foreground'
        } ${popping ? 'animate-heart-pop' : ''}`}
        strokeWidth={1.6}
      />
    </Button>
  );
};

export default FavoriteHeart;
